import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Search } from 'lucide-react';
import { User } from '@/types';

interface AdvancedUserSearchProps {
  onSearch: (users: User[]) => void;
  allUsers: User[];
}

export default function AdvancedUserSearch({ onSearch, allUsers }: AdvancedUserSearchProps) {
  return (
    <div className="space-y-4">
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Search className="h-5 w-5" />
            Advanced Search
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <Input placeholder="Search by name..." />
            <Input placeholder="Search by email..." />
            <Input placeholder="Search by job title..." />
            <Input placeholder="Search by site..." />
          </div>
          <div className="flex justify-end">
            <Button onClick={() => onSearch(allUsers)}>
              <Search className="h-4 w-4 mr-2" />
              Search
            </Button>
          </div>
          <p className="text-muted-foreground text-sm">
            Advanced search functionality is not fully implemented in this prototype.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}